<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    width="1000px"
    :before-close="handleClose"
  >
    <div id="print">
      <!-- 修改表格结构 -->
      <table class="gh-table">
        <!-- 固定表头部分 -->
        <thead>
          <tr>
            <th colspan="24" style="padding: 0;">入库单</th>
          </tr>
          <tr>
            <th colspan="4">仓库名称：</th>
            <td colspan="20">{{ data.positionName }}</td>
          </tr>
          <tr>
            <th colspan="4">单据时间：</th>
            <td colspan="8">{{ data.ordTime }}</td>
            <th colspan="4">业务时间：</th>
            <td colspan="8">{{ data.businessTime }}</td>
          </tr>
          <tr>
            <th colspan="4">入库类型：</th>
            <td colspan="8">{{ data.inTypeName }}</td>
            <th colspan="4">来源类型：</th>
            <td colspan="8">{{ data.sourceTypeSign }}</td>
          </tr>
          <!-- 列标题行（每页重复的核心部分） -->
          <tr class="fixed-header">
            <th colspan="2">药品编码</th>
            <th colspan="2">药品名称</th>
            <th colspan="2">供应商</th>
            <th colspan="2">生产商</th>
            <th colspan="2">品质</th>
            <th colspan="2">产地</th>
            <th colspan="2">生产日期</th>
            <th colspan="2">保质期</th>
            <th colspan="2">批次号</th>
            <th colspan="2">入库数量</th>
            <th colspan="2">成本单价</th>
            <th colspan="2">成本金额</th>
          </tr>
        </thead>

        <!-- 表格内容 -->
        <tbody>
          <tr v-for="(value,index) in list" :key="index">
            <td colspan="2">{{ value.materielCode }}</td>
            <td colspan="2">{{ value.materielName }}</td>
            <td colspan="2">{{ value.supplierName }}</td>
            <td colspan="2">{{ value.manufacturerName }}</td>
            <td colspan="2">{{ toJson(jsonStr.qualitySign,value.qualitySign) }}</td>
            <td colspan="2" />
            <td colspan="2" />
            <td colspan="2" />
            <td colspan="2">{{ value.batchCode }}</td>
            <td colspan="2">{{ value.number }}</td>
            <td colspan="2">{{ value.costPrice }}</td>
            <td colspan="2">{{ value.costAmount }}</td>
          </tr>
        </tbody>

        <!-- 底部汇总 -->
        <tfoot>
          <tr>
            <th colspan="4">仓管签字：</th>
            <th colspan="20" />
          </tr>
        </tfoot>
      </table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handlePrint">打 印</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      data: {},
      list: [],
      jsonStr: {
        positionSign: '[{"key": "1", "value": "药房"}, {"key": "2", "value": "药库"}]',
        classifySign: '[{"key": "1", "value": "中成药"}, {"key": "3", "value": "饮片"}, {"key": "5", "value": "产品"}]',
        qualitySign: '[{"key": "1", "value": "普通"}, {"key": "2", "value": "精品"}]',
        executeSign: '[{"key": "1", "value": "草稿"}, {"key": "2", "value": "完成"}]',
        sourceTypeSign: '[{"key": "1", "value": "采购"}, {"key": "2", "value": "盘点"}, {"key": "3", "value": "退货"}]'
      }
    }
  },
  methods: {
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    open(data) {
      console.log(data)
      this.data = data.head
      this.list = data.body.inOrdItem
      this.dialogVisible = true
    },
    toJson(jsonStr, value) {
      const json = JSON.parse(jsonStr)
      let data = ''
      json.forEach(element => {
        if (element.key === value) {
          data = element.value
        }
      })
      return data
    },
    handlePrint() {
      // 1. 获取打印内容
      const printContent = document.getElementById('print').innerHTML

      // 2. 创建打印窗口
      const printWindow = window.open('', '_blank', 'width=800,height=600')
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>入库单打印</title>
            <style>
              /* 打印专用样式 */
              @media print {
                @page {
                  size: A4 landscape; /* 横向设置 */
                  margin: 10mm;
                }
                body {
                  margin: 0;
                  padding: 0;
                  width: 100%;
                }
                .print-container {
                  width: 100% !important;
                  max-width: 277mm; /* A4横向可用宽度 */
                  margin: 0 auto;
                  font-size: 14px;
                }
                table {
                  width: 100% !important;
                  border-collapse: collapse;
                }
                th, td {
                  border: 1px solid #000;
                  padding: 4px;
                  word-break: break-all;
                  font-size: 14px;
                }
              }
            </style>
          </head>
          <body>
            <div class="print-container">
              ${printContent}
            </div>
            <script>
              // 自动触发打印
              window.onload = function() {
                window.print();
                setTimeout(function() {
                  window.close();
                }, 100);
              }
            <\/script>
          </body>
        </html>
      `)
      printWindow.document.close()
    }
  }
}
</script>
<style scoped>
/* 添加打印样式 */
@media print {
  .fixed-header {
    display: table-header-group;
    page-break-inside: avoid;
  }

  /* 确保表头在每页重复 */
  thead {
    display: table-header-group;
  }

  /* 防止行内分页 */
  tr {
    page-break-inside: avoid;
  }

  /* 重置打印边距 */
  body {
    margin: 0;
    padding: 15mm;
  }
}
</style>
